"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.StyledAccordion = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const material_1 = require("@mui/material");
const ui_theme_1 = require("@kyruus/ui-theme");
const MUIAccordionComponent = (0, ui_theme_1.withMuiThemeAdapter)(material_1.Accordion);
const AccordionComponent = (props) => (react_1.default.createElement(MUIAccordionComponent, Object.assign({}, props)));
AccordionComponent.displayName = 'Accordion';
exports.StyledAccordion = (0, styled_1.default)(AccordionComponent, {
    shouldForwardProp: (prop) => prop !== 'offsetTop'
}) `
  &&.MuiAccordion-root {
    background-color: transparent;
    margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
    border: none;
    box-shadow: none;

    .MuiAccordionSummary-root,
    .MuiAccordionSummary-root.Mui-expanded {
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      position: sticky;
      z-index: 100;
      top: ${(props) => typeof props.offsetTop === 'string'
    ? props.offsetTop
    : `${props.offsetTop}px`};
      background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
      min-height: 48px;
      padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')};
      border: solid 1px ${(0, ui_theme_1.fromTheme)('color_border')};
      transition: border 0.1s ease-out;

      > .MuiAccordionSummary-content {
        margin: 0;
      }

      .MuiIconButton-label {
        color: ${(0, ui_theme_1.fromTheme)('color_text')};
      }
    }

    .MuiAccordionSummary-root.Mui-focusVisible {
      background-color: ${(0, ui_theme_1.fromTheme)('color_item_hover')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
    }

    .MuiAccordionDetails-root {
      padding: 0;
      display: block;
    }
  }

  &&.MuiAccordion-root:last-of-type {
    margin: 0;
  }

  &&.MuiAccordion-root:before {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  }
`;
exports.StyledContainer = styled_1.default.div `
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border: solid 1px ${(0, ui_theme_1.fromTheme)('color_border')};
  transition: box-shadow 0.1s ease-out, background-color 0.1s ease-out;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_large')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};

  :focus-within {
    box-shadow: inset 2px 0 ${(0, ui_theme_1.fromTheme)('color_border_info')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_info_secondary')};
  }
`;
//# sourceMappingURL=styles.js.map